import cn from 'classnames'
import { ReactNode } from 'react'

import styles from './Header.module.scss'

interface IProps {
  className?: string
  children: ReactNode
}

export const Header = ({ children, className }: IProps) => {
  return <div className={cn(styles.root, className)}>{children}</div>
}
